import script from "./SignInPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignInPage.vue?vue&type=script&setup=true&lang=js"

import "./SignInPage.vue?vue&type=style&index=0&id=dbcb0cf2&lang=scss"

const __exports__ = script;

export default __exports__